// extracted by mini-css-extract-plugin
export default {"instruction":"_1qf2vuelOPmz9a4WfZj6yj"};